import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglass, faHourglassClock } from '@fortawesome/pro-solid-svg-icons';
import {
    faPaintBrush,
    faBath,
    faTooth,
    faDogLeashed,
    faAlarmClock,
    faShieldDog,
    faDog,
    faPaw
} from '@fortawesome/pro-regular-svg-icons';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            width: '100%'
        },
        heading: {
            fontSize: '24px',
            color: '#333',
            marginTop: 0,
            marginBottom: '20px',
            fontWeight: 'bold'
        },
        list: {
            listStyleType: 'none',
            padding: 0,
            margin: 0
        },
        listItem: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '12px',
            color: '#333',
            fontSize: '16px'
        },
        icon: {
            width: '24px',
            marginRight: '10px',
            color: '#555'
        }
    })
);

const AddonDescription = () => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <ul className={classes.list}>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faHourglass}
                        className={classes.icon}
                    />
                    15-Minute Dematting
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faHourglassClock}
                        className={classes.icon}
                    />
                    30-Minute Dematting
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faPaintBrush}
                        className={classes.icon}
                    />
                    De-Shedding
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faBath}
                        className={classes.icon}
                    />
                    Medicated Ear Cleaning
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faTooth}
                        className={classes.icon}
                    />
                    Biter Fees
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faDogLeashed}
                        className={classes.icon}
                    />
                    Walking
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faAlarmClock}
                        className={classes.icon}
                    />
                    Late Pick-up
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faShieldDog}
                        className={classes.icon}
                    />
                    Blueberry Facial
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faDog}
                        className={classes.icon}
                    />
                    Pick-up/Drop-off Service
                </li>
                <li className={classes.listItem}>
                    <FontAwesomeIcon
                        icon={faPaw}
                        className={classes.icon}
                    />
                    Nail Painting
                </li>
            </ul>
        </Box>
    );
};

export default AddonDescription;
